<template>
    <div style="page-break-before: always" class="w-full">
        <app-separator tag="h1" :label="$t('project.follow.meetings.description')"></app-separator>
        <div class="text-xs border">
            <span v-html="meeting.description" />
        </div>
    </div>
</template>
<script>
import AppSeparator from '@/components/appSeparator/AppSeparator';
import { getMeeting } from '@/features/meetings/meetings.service';

export default {
    components: { AppSeparator },
    async created() {
        this.subscriptions = [
            getMeeting(this.$route.params.projectId, this.$route.params.meetingId).subscribe((meeting) => {
                this.meeting = meeting;
            }),
        ];
    },
    data() {
        return {
            meeting: null,
        };
    },
};
</script>
